import DeviceDetector from 'device-detector-js';

export async function getPublicIpAddress(): Promise<string> {
	try {
		const response = await fetch('https://api.ipify.org?format=json');
		const data = await response.json();
		return data.ip || '';
	} catch {
		return '';
	}
}

export interface DeviceFingerprint {
	os?: string;
	device?: string;
	screenWidth: number;
	screenHeight: number;
	availWidth: number;
	availHeight: number;
	devicePixelRatio: number;
	timezone: string;
	hardwareConcurrency?: number;
	deviceMemory?: number;
}

export function collectFingerprint(): DeviceFingerprint {
	const detector = new DeviceDetector();
	const deviceInfo = detector.parse(navigator.userAgent);

	return {
		os: deviceInfo.os?.name,
		device: deviceInfo.device?.type,
		screenWidth: window.screen.width,
		screenHeight: window.screen.height,
		availWidth: window.screen.availWidth,
		availHeight: window.screen.availHeight,
		devicePixelRatio: window.devicePixelRatio || 1,
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		hardwareConcurrency: navigator.hardwareConcurrency,
		deviceMemory: (navigator as unknown as { deviceMemory?: number }).deviceMemory,
	};
}
